/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_update_join_request_v1_workspace__slug__join_requests_patch } from '../models/Body_update_join_request_v1_workspace__slug__join_requests_patch';
import type { Workspace } from '../models/Workspace';
import type { WorkspaceAlert } from '../models/WorkspaceAlert';
import type { WorkspaceCreate } from '../models/WorkspaceCreate';
import type { WorkspaceJoinRequest } from '../models/WorkspaceJoinRequest';
import type { WorkspaceUpdate } from '../models/WorkspaceUpdate';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class WorkspaceService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * List Workspace
   * @returns Workspace Successful Response
   * @throws ApiError
   */
  public listWorkspaceV1WorkspaceGet(): CancelablePromise<Array<Workspace>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace',
    });
  }

  /**
   * Create Workspace
   * @param requestBody
   * @returns Workspace Successful Response
   * @throws ApiError
   */
  public createWorkspaceV1WorkspacePost(
    requestBody: WorkspaceCreate
  ): CancelablePromise<Workspace> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        409: `Conflict`,
        412: `Precondition Failed`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * @deprecated
   * Get Workspace
   * @param slug
   * @returns Workspace Successful Response
   * @throws ApiError
   */
  public getWorkspaceV1WorkspaceSlugGet(slug: string): CancelablePromise<Workspace> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
        429: `Too Many Requests`,
      },
    });
  }

  /**
   * Modify Workspace
   * @param slug
   * @param requestBody
   * @returns Workspace Successful Response
   * @throws ApiError
   */
  public modifyWorkspaceV1WorkspaceSlugPatch(
    slug: string,
    requestBody: WorkspaceUpdate
  ): CancelablePromise<Workspace> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/workspace/{slug}',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Insufficient privileges`,
        409: `Workspace email already exists`,
        422: `Invalid workspace email`,
      },
    });
  }

  /**
   * List Join Requests
   * @param slug
   * @returns WorkspaceJoinRequest Successful Response
   * @throws ApiError
   */
  public listJoinRequestsV1WorkspaceSlugJoinRequestsGet(
    slug: string
  ): CancelablePromise<Array<WorkspaceJoinRequest>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/join-requests',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Join Request
   * @param slug
   * @param requestBody
   * @returns WorkspaceJoinRequest Successful Response
   * @throws ApiError
   */
  public updateJoinRequestV1WorkspaceSlugJoinRequestsPatch(
    slug: string,
    requestBody: Body_update_join_request_v1_workspace__slug__join_requests_patch
  ): CancelablePromise<WorkspaceJoinRequest> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/workspace/{slug}/join-requests',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Workspace Service Alert
   * 서비스 차원에서 우선 해결해야 할 워크스페이스 알림을 가져옵니다.
   * @param slug
   * @returns WorkspaceAlert Successful Response
   * @throws ApiError
   */
  public getWorkspaceServiceAlertV1WorkspaceSlugAlertGet(
    slug: string
  ): CancelablePromise<WorkspaceAlert> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/alert',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
